function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9070"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5700"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40395",
    d: "M-616.4 1149.766c-1.618-.922-3.239-1.837-4.852-2.767l-13.4-7.727a.763.763 0 0 1-.443-.777q.018-10.315.014-20.63c0-.209-.123-.483.189-.605a7.755 7.755 0 0 0 1.547.99c1.066.609 2.134 1.213 3.2 1.83 1.263.734 2.538 1.445 3.781 2.211.24.148.556.136.754.368 1.289.761 2.593 1.5 3.886 2.252 1.694.989 3.407 1.945 5.088 2.957.194.117.367.232.378.486.02 6.952.005 13.9.007 20.852a.684.684 0 0 1-.149.56z",
    transform: "translate(635.107 -1104.962)",
    style: {
      fill: "#e5b323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40396",
    d: "M-400.86 1184.18c1.033 0 2.065-.019 3.1 0a2.293 2.293 0 0 1 2.289 2.293q.011 10.119 0 20.238a2.241 2.241 0 0 1-2.252 2.259q-6.9.018-13.792 0a2.22 2.22 0 0 1-2.249-2.3c-.011-1.766-.009-3.531-.013-5.3a.939.939 0 0 1-.136-.668v-14.176a2.432 2.432 0 0 1 2.44-2.5 18.8 18.8 0 0 1 3.036.06c.208.108.2.33.267.512a1.569 1.569 0 0 0 1.367 1.153 25.862 25.862 0 0 0 4.139.035 1.653 1.653 0 0 0 1.63-1.307.485.485 0 0 1 .174-.299z",
    transform: "translate(443.468 -1162.778)",
    style: {
      fill: "#e0e0df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40397",
    d: "M-478.383 1126.515h-2.994a2.287 2.287 0 0 0-2.394 2.375q-.009 7.085 0 14.171c0 .216 0 .432-.008.648l-10.774 6.2c-.107.006-.144-.055-.148-.151-.006-.133 0-.266 0-.4v-20.837c-.066-.449.312-.548.586-.7 1.323-.731 2.62-1.508 3.931-2.26 3-1.718 5.983-3.454 8.978-5.175 1.713-.984 3.4-2.01 5.143-2.943.152.077.124.221.123.349q0 3.451-.013 6.9c-.133.171-.327.138-.506.147a1.628 1.628 0 0 0-1.758 1.374c-.04.114-.054.234-.166.302z",
    transform: "translate(513.469 -1105.122)",
    style: {
      fill: "#ad871b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40398",
    d: "M-536.8 1082.126c-.109.435-.565.434-.849.609a97.708 97.708 0 0 1-3.732 2.173c-1.231.684-2.448 1.395-3.671 2.092-1.408.8-2.809 1.62-4.213 2.431-1.179.681-2.368 1.344-3.546 2.027-.865.5-1.72 1.024-2.579 1.537q-.058.063-.1-.013c-.831-.492-1.657-.993-2.494-1.474-.741-.425-1.5-.817-2.242-1.244s-1.481-.9-2.228-1.335c-.774-.453-1.559-.888-2.339-1.331-.1-.379.241-.429.446-.55 1.714-1.018 3.449-2 5.176-3q4.836-2.788 9.665-5.589c.876-.508 1.783-.965 2.628-1.527a1.244 1.244 0 0 1 .59-.253.984.984 0 0 1 .186.063q4.652 2.691 9.302 5.384z",
    transform: "translate(574.2 -1069.804)",
    style: {
      fill: "#89690f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40399",
    d: "M-605.82 1042.695a19.193 19.193 0 0 1-2.233 1.366c-1.466.866-2.946 1.708-4.424 2.553-1.823 1.043-3.667 2.05-5.469 3.129-1.379.826-2.784 1.606-4.168 2.422-.6.353-1.206.691-1.8 1.048-.162.1-.375.162-.41.4-.505-.283-1.03-.528-1.523-.838-.735-.462-1.5-.869-2.259-1.3-.78-.445-1.535-.933-2.336-1.345-.737-.379-1.438-.827-2.152-1.249a4.3 4.3 0 0 0-.462-.26c-.212-.093-.482-.18-.462-.505q5.326-3.086 10.653-6.17 3.776-2.184 7.554-4.363a.58.58 0 0 1 .676-.033q4.307 2.508 8.63 4.991a1.428 1.428 0 0 1 .185.154z",
    transform: "translate(633.733 -1035.819)",
    style: {
      fill: "#ad871b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40400",
    d: "M-372.461 1173.546a1.748 1.748 0 0 1 1.975-1.811c.149 0 .3-.005.448-.008l3.126.012a1.78 1.78 0 0 1 1.971 1.816 1.677 1.677 0 0 1-1.674 1.711 26.812 26.812 0 0 1-4.189 0 1.671 1.671 0 0 1-1.657-1.72z",
    transform: "translate(407.547 -1152.155)",
    style: {
      fill: "#005193"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40401",
    d: "M-495.06 1198.708c.033.006.065.01.1.013v20.981c0 .205-.088.436.1.615-.062.089-.129.108-.206.017q.004-10.812.006-21.626z",
    transform: "translate(513.771 -1175.53)",
    style: {
      fill: "#df8b69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40403",
    d: "M-394.807 1222.788c0-.5-.006-1 0-1.5.008-.539.26-.81.782-.815 1.031-.01 2.062 0 3.093 0a.691.691 0 0 1 .769.5 1.116 1.116 0 0 1-.215 1.207.55.55 0 0 1-.811.028c-.308-.387-.683-.337-1.074-.337-1.144 0-1.14 0-1.146 1.127 0 .389-.078.763.451.938.286.095.314.453.236.745a.615.615 0 0 1-.575.479 4.14 4.14 0 0 1-.9 0 .67.67 0 0 1-.613-.724c.001-.551.004-1.1.003-1.648z",
    transform: "translate(426.909 -1194.386)",
    style: {
      fill: "#e0e0df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40405",
    d: "M-380.075 1229.446a.659.659 0 0 1-.209-.065 6.15 6.15 0 0 1-1.479-1.464.592.592 0 0 1 .165-.808.638.638 0 0 1 .786-.072 1.8 1.8 0 0 1 .162.115c.231.17.378.579.655.515.249-.058.438-.385.65-.6.425-.423.843-.853 1.273-1.271a.736.736 0 0 1 1.064-.09.69.69 0 0 1-.068 1.057c-.793.808-1.6 1.6-2.4 2.4a.851.851 0 0 1-.599.283z",
    transform: "translate(415.692 -1198.763)",
    style: {
      fill: "#005193"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40408",
    d: "M-334.253 1233.047h2.1c.427 0 .724.175.762.616a.645.645 0 0 1-.6.725 2.7 2.7 0 0 1-.493.057q-1.774.007-3.548 0a2.511 2.511 0 0 1-.446-.039c-.479-.089-.736-.365-.684-.755.063-.469.365-.62.815-.608.695.017 1.395.004 2.094.004z",
    transform: "translate(376.973 -1205.278)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40411",
    d: "m-381.371 1341.678.123-.01a.683.683 0 0 1 .3.3l-.139.011z",
    transform: "translate(415.267 -1299.394)",
    style: {
      fill: "#cfd27e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.177b8996625eb8163d46a8537dcf9d0f.svg";
export { ForwardRef as ReactComponent };